<script>

	import Checkbox from '../ui/Checkbox.svelte';

	export let field;
	export let response = [];

</script>

<style>
	.checkboxes {
		padding: 0 1em 0.5em 1em;
		color: var(--fieldTextColor);
	}
	:global(.outline) .checkboxes {
		color: var(--textColor);
	}
	:global(.linear.outline) .checkboxes {
		padding: 0 0 0.5em 0;
	}
	:global(.linear.solid) .checkboxes {
		padding: 0.3em 1em 0.5em 1em;
	}
</style>

{#if field.options}
	<div class="checkboxes">
		{#each field.options as o}
			<p>
				<Checkbox>
					<input
						type="checkbox"
						id="azn_s_i_{field.ref}_{o.ref}"
						name={field.ref}
						bind:group={response}
						value={o.ref}
					>
				</Checkbox>
				<label for="azn_s_i_{field.ref}_{o.ref}">{o.name.EN}</label>
			</p>
		{/each}
	</div>
{/if}
